import React, { useEffect, useState } from 'react';


import { IField } from '../../../../../shared/interfaces';
import { Indici_FormMode } from '../../../../../shared/enums';
import DynamicForm from '../../../../DynamicForm/DynamicForm';
import AppUtilities from '../../../../../shared/Utilities/appUtilities';
import CircleLoader from '../../../../Loader/CircleLoader/CircleLoader';

export interface IndiciProps {
    loading?: boolean
    fields?: IField[]
    extraCssClass?: string
    onIndiciInputChangedHandler: (newField: IField) => void

}

const Indici: React.FunctionComponent<IndiciProps> = (props) => {

    let loading = props.loading !== undefined ? props.loading : false;


    return (
        <div className={`indici-component flex flex-column position-relative ${props.extraCssClass}`}>

            <CircleLoader loaderClass='loader-large' loading={loading} />

            <div className={'my-scroll-div' }>
            
                <div className={`my-component-content`}>

                    <DynamicForm
                        fields={props.fields}
                        extraCssClass="indici"
                        onInputChangedHandler={(newField) => { props.onIndiciInputChangedHandler(newField) }}
                        
                    />
                </div>
            </div>
            

        </div>


    );
};


export default Indici;



